import { useState, useEffect } from 'react';
import { getThumbnailUrl } from '@/lib/thumbnail';

interface VideoThumbnailProps {
  playbackId: string | null;
  playbackPolicy?: string | null;
  className?: string;
  alt?: string;
}

export function VideoThumbnail({ playbackId, playbackPolicy, className, alt }: VideoThumbnailProps) {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!playbackId) {
      setThumbnailUrl(null);
      setLoading(false);
      return;
    }

    let mounted = true;
    
    getThumbnailUrl(playbackId, playbackPolicy)
      .then(url => {
        if (mounted) {
          setThumbnailUrl(url);
          setLoading(false);
        }
      })
      .catch(error => {
        console.error('Failed to get thumbnail URL:', error);
        if (mounted) {
          setThumbnailUrl(null);
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [playbackId, playbackPolicy]);

  if (loading) {
    return (
      <div className={`bg-gray-200 animate-pulse ${className || ''}`}>
        <div className="w-full h-full bg-gray-300 rounded"></div>
      </div>
    );
  }

  if (!thumbnailUrl) {
    return (
      <div className={`bg-gray-100 flex items-center justify-center ${className || ''}`}>
        <div className="text-gray-400 text-sm">No thumbnail</div>
      </div>
    );
  }

  return (
    <img 
      src={thumbnailUrl} 
      alt={alt || 'Video thumbnail'} 
      className={className || ''}
      onError={(e) => {
        console.error('Thumbnail failed to load:', thumbnailUrl);
        // Hide the image if it fails to load
        e.currentTarget.style.display = 'none';
      }}
    />
  );
}
